<style>
  *{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
  .goodsManageTable{
    width:100%;
  }
  .goodsManageTable .el-form-item .el-cascader{
    width: 100%;
  }
  .goodsManageTable .el-form-item .el-select{
    width: 100%;
  }
  .el-table .cell{
    text-align: center;
    min-height:15px;
  }
  .hover:hover{
    color: #6851ff;
  }
  .albumMeng{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(75, 75, 75, 0.3);
  }
</style>

<template>
  <div class='goodsManageTable'>
    <el-table ref="multipleTable" max-height='630' @filter-change='filterChange' :border='true' :header-cell-style='{"background-color":"#333",color:"#eee"}' :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" v-if='deleteType'/>
      <el-table-column type='index' label="序号" width="50"/>
      <el-table-column  label="名称">
        <template slot-scope="scope"><span>{{ scope.row.name }}</span></template>
      </el-table-column>
      <el-table-column  label="颜色数量">
        <template slot-scope="scope"><span>{{ scope.row.color_description }}</span></template>
      </el-table-column>
      
      <el-table-column  label="运费">
        <template slot-scope="scope"><span>{{ scope.row.postage?scope.row.postage:'暂无' }}</span></template>
      </el-table-column>
      <el-table-column  label="说明">
        <template slot-scope="scope"><span>{{ scope.row.content?scope.row.content:'' }}</span></template>
      </el-table-column>
      <el-table-column  label="电子版">
        <template slot-scope="scope">
          <div v-if="scope.row.e_edition" @click="toEdition(scope.row)" style="cursor: pointer;">
            <div><i class="el-icon-notebook-2" style="fontSize:24px;"></i></div>
            <span style="color:#5757fa;">查看</span>
          </div>
          <span v-if="!scope.row.e_edition" @click="toEdition(scope.row)" style="color:#5757fa;cursor: pointer;" >设置</span>
        </template>
      </el-table-column>
      <el-table-column  label="图片">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px ; cursor: pointer;" :src="scope.row.pictures[0] ? scope.row.pictures[0].url : '' +'?x-oss-process=image/resize,m_fill,h_50,w_50'" fit="cover"  @click="showUpImg(scope.row)">
            <div slot="error" class="image-slot" @click="showUpImg(scope.row)">
              <i  style='cursor: pointer;' class='el-icon-picture'></i>
            </div>
          </el-image>
          <p v-if="scope.row.pictures.length">{{scope.row.pictures.length}}张</p>
        </template>
      </el-table-column>
      <el-table-column  label="采购价">
        <template slot-scope="scope"><span>{{ scope.row.pur_price }}</span></template>
      </el-table-column>
      <el-table-column  label="分仓价">
        <template slot-scope="scope"><span>{{ scope.row.adj_price }}</span></template>
      </el-table-column>
      <el-table-column  label="会员价">
        <template slot-scope="scope"><span>{{ scope.row.price }}</span></template>
      </el-table-column>
      <el-table-column  label="零售价">
        <template slot-scope="scope"><span>{{ scope.row.ret_price }}</span></template>
      </el-table-column>
      <el-table-column  label="操作">
        <template slot-scope="scope"><span @click="changeAlbum(scope.row)" style="color:#6376F7;cursor: pointer;">编辑</span></template>
      </el-table-column>
    </el-table>
    <div class="albumMeng" v-if="albumBoxShow" @click="albumBoxShow = false"></div>
    <albumBox v-if="albumBoxShow" :info='needChangeData.id?needChangeData:""' @hidealbumBox='hidealbumBox' @getList='refreshTable' :type='albumType'></albumBox>
    <UpdateImg :pictures='pictures' :clickRowId='clickRowId' v-if="imgBoxShow" @hideUpImg='hideUpImg'></UpdateImg>
    <!-- <p style='text-align: right;margin-top:30px;'><el-button v-show='nowPage>1' @click='changePage(-1)'>上一页</el-button><el-button v-show='(allPage-nowPage)>0' @click='changePage(1)'>下一页</el-button></p> -->
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handlePageChange"
        :page-size="form.limit"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
    import albumBox from './albumBox'
    import UpdateImg from './updateImg'

    import { processingFilterOptions, getKeyValueWithFilter } from '../../../../util/processingData';
    // import { getObjectList, getFilterOptions } from '../../../../util/requests';

  export default {
    components: {
      albumBox,
      UpdateImg
    },
    props: {
      'deleteType':{
        type:Boolean,
        default:false,
      },
      'albumType': {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        type:0,
        imgBoxShow:false,
        pictures:[],
        clickRow:'',
        clickRowId:0,
        needChangeData:{},
        albumBoxShow:false,
        tableData: [],
        total:0,
        multipleSelection: [],
        nowPage:1,
        allPage:1,
        form:{
          supplier_id: this.$store.state.supplierInfo?this.$store.state.supplierInfo.id : 0,
          uid: this.$store.state.userInfo.id,
          page: 1,
          part_type:'album',
          // has_count: this.list.length,
          limit: 20,
          class:'画册'
          // type:0,
        },
      }


    },
    computed: {
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
        },
        userInfo(){
          return this.$store.state.userInfo
        },
        deleteCount(){
          return this.multipleSelection.length
        }
    },
    watch:{
      deleteCount(val){
        this.$emit('changeDeleteCount',val)
      },
      albumType(value) {
        this.form.class = value;
        this.updateTable(1);
        // this.form.page = 1;
      }
      // type(val){
      //   if(val == 0){
      //     this.form.class = '画册'
      //   }else{
      //     this.form.class = '色卡'
      //   }
      // }
    },
    mounted() {
      this.form.supplier_id=this.supplier_id
      this.form.class = this.albumType;
      // this.updateTable(1);
    },
    methods: {
      handlePageChange(page) {
        this.form.page = page;
        // this.getList();
        this.updateTable(page);
      },
      refreshTable() {
				this.form.page = 1;
				this.updateTable(1);
      },
      updateTable(page) {
        // 通过当前过滤器，获取keyValue，传入getObjectList方法，获取到过滤规则下的商品列表
        const keyValue = getKeyValueWithFilter(this.filters);
				keyValue.part_type = this.form.part_type;
        keyValue.limit = this.form.limit;
        keyValue.class = this.form.class;
        if (this.form.name) {
          keyValue.name = this.form.name;
        }
        this.$requests.getObjectList(
          this.form.uid,
          this.form.supplier_id,
          keyValue,
          page
        ).then((res) => {
          if (res.list.length == 0 && res.count !== 0) {
            this.form.page--;
            this.updateTable(this.form.page);
            return;
          }
          this.total = res.count;
          this.tableData = res.list;
        })
      },
      toEdition(row){
        this.clickRow = row
        this.$prompt('请输入电子版链接（门图网电子书）', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue:row.e_edition?row.e_edition:''  //默认值
        }).then(({ value }) => {
          let Update = {
            id:row.id,
            type: 'album',
            sub_type:this.clickRow.class,
            name:this.clickRow.name,
            price:this.clickRow.ret_price,
            vip_price:this.clickRow.price,
            picture:this.clickRow.pictures,
            data:{
                postage:this.clickRow.postage,
                content:this.clickRow.content,
                color_description:this.clickRow.color_description,
                e_edition:value
            }
          }
          // this.axios.post('https://ggtools.thinkerx.com/erp/add_other_commodity',Update).then(res => {
          //   if(res.data.status == 1){
          //     this.$message.success('链接添加成功')
          //     this.getList()
          //   }
          // })
          this.$post("/py/erp/add_other_commodity",Update,res => {
            if(res.status == 1){
              this.$message.success('链接添加成功')
              // this.getList()
              this.updateTable(this.form.page)
            }
          })
        }).catch(() => {

        });
      },
      setType(typeValue){
        this.type = typeValue
        // this.form.type = typeValue
        this.form.page = 1
        this.nowPage = 1
        // this.getList()
        this.updateTable(1)
      },
      changeAlbum(data){
        this.albumBoxShow = !this.albumBoxShow
        if(data){
          this.needChangeData = data
        }else{
          this.needChangeData = {}
        }
      },
      hidealbumBox(){
        this.albumBoxShow = false
      },
      changePage(cha){
        this.form.page+=cha
        this.nowPage+=cha
        this.getList()
      },
      getList(){
        let form = this.form
        form.uid = this.userInfo.id
        // this.axios.get('https://ggtools.thinkerx.com/erp/get_product_album',{
        //   params:form
        // }).then(res => {
        //   // console.log(res.data.data.list)
        //   let list = res.data.data.list
        //   this.tableData = list
        //   this.allPage = Math.ceil(res.data.data.total/this.form.limit)
        // })
        this.$get("/py/erp/get_product_album",form,res => {  
          let list = res.data.list
          this.tableData = list
          this.allPage = Math.ceil(res.data.total/this.form.limit)
        })
        // this.$post('/cloudStorage/getAlbumList',form,res => {
        //   let data = res.data
        //   this.allPage = data.all_page
        //   this.total = data.count
        //   let list = data.list
        //   list.forEach(item => {
        //     if(item.pictures){
        //       item.pictures = JSON.parse(item.pictures)
        //     }
        //   })
        //   this.tableData = list
        // })
        // this.$post('/contact/customer_list',this.formData,res => {
        //   let list = res.data.list
        //   this.allPage = res.data.totalPage
        //   list.forEach(item => {
        //     item.tag = item.tag.split(',')
        //   })
        //   this.tableData = list
        // })
      },

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      clearDelete(){
        this.$refs.multipleTable.clearSelection();
      },
      deleteGoods(){
        let idArr = []
        let multipleSelection = this.multipleSelection
        for(let i in multipleSelection){
          idArr.push(multipleSelection[i].id)
        }
        // this.axios.post('https://ggtools.thinkerx.com/erp/delete_product_list',{ids:idArr}).then(res => {
        //   if(res.data.status == 1){
        //     this.$message.success('删除成功')
        //     this.getList()
        //   }
        // })
        this.$post("/py/erp/delete_product_list",{
          ids:idArr
        },res => {
           if(res.status == 1){
            this.$message.success('删除成功')
            // this.getList()
            this.updateTable(this.form.page)
          }
        })

      },
      filter(keywords){
          // this.formData.page=0
          // this.formData.key=keywords
          this.form.page = 1;
          this.form.name = keywords;
          // this.getList()
          this.updateTable(1)
      },
      filterChange(change){
        for (let key in change){
          this.formData[key]=change[key][0]
        }
        this.getList()
      },
      filterHandler(value, row, column) {
        return row
      },
      showUpImg(row){
        // return
        // 传给弹窗的imgUrl
        this.pictures = row.pictures
        this.clickRowId = row.id
        this.clickRow=row
        this.imgBoxShow = true
      },
      hideUpImg(nowPictures,id){
        this.imgBoxShow = false
        // 回调的imgUrl
        // console.log(nowPictures)
        if(nowPictures&&id){
          let Update = {
            id:id,
            type: 'album',
            sub_type:this.clickRow.class,
            name:this.clickRow.name,
            price:this.clickRow.ret_price,
            vip_price:this.clickRow.price,
            picture:nowPictures,
            data:{
                postage:this.clickRow.postage,
                content:this.clickRow.content,
                color_description:this.clickRow.color_description
            }
          }
          // this.axios.post('https://ggtools.thinkerx.com/erp/add_other_commodity',Update).then(res => {
          //   if(res.data.status == 1){
          //     this.$message.success('图片编辑成功')
          //   }
          // })
          this.$post("/py/erp/add_other_commodity",Update,res => {
            if(res.status == 1){
              this.$message.success('图片编辑成功')
            }
          })
        }
      }
    }
  }
</script>
